import script from "./ComponenteUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponenteUsuario.vue?vue&type=script&setup=true&lang=js"

import "./ComponenteUsuario.vue?vue&type=style&index=0&id=66dfb8de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dfb8de"]])

export default __exports__